import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './account/Login';
import HomePage from './containers/Home/HomePage';
import AuthContainer from './account/authContainer';
import Activate from './account/Activate';
import Home from './pages/home/Home';
import DailyView from './pages/home/DailyView';
import MemoryPage from './pages/MemoryPage';
import QuranPage from './pages/QuranPage';
import ResetPassword from './account/ResetPassword';
import ReviewSummary from './pages/ReviewSummary';
import ResetPasswordConfirm from './account/ResetPasswordConfirm';
import GoogleOAuthCallback from './account/GoogleOAuthCallback';
import ReviewTest from './pages/ReviewTest';
import OrderingTest from './pages/OrderingTest';
import CompleteTest from './pages/CompleteTest';
import LinkingTest from './pages/LinkingTest';
import WritingTest from './pages/WritingTest';
function App() {
  return (
    <Router>
      <Routes>
        <Route path='/activate/:uid/:token' element={<Activate />} />
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<AuthContainer />} />
        <Route path="/home" element={<DailyView />} />
        <Route path="/memory" element={<MemoryPage />} />
        <Route path="/quran" element={<QuranPage />} />
        <Route path="/forget-password" element={<ResetPassword />} />
        <Route path="/password/reset/confirm/:uid/:token" element={<ResetPasswordConfirm />} />
        <Route path="/review-summary" element={<ReviewSummary />} />
        <Route path="/oauth-callback" element={<GoogleOAuthCallback />} />
        <Route path="/review-test" element={<ReviewTest />} />
        <Route path="/ordering-test" element={<OrderingTest />} />
        <Route path="/complete-test" element={<CompleteTest />} />
        <Route path="/linking-test" element={<LinkingTest />} />
        <Route path="/writing-test" element={<WritingTest />} />

      </Routes>
    </Router>
  );
}

export default App;
